/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  powerOutputFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('powerOutputFilterController', ['$scope',
      function ($scope) {
        $scope.componentName = "powerOutputFilter";

        $scope.resetFilter = function () {
          delete $scope.criteria["megawattsFrom"];
          delete $scope.criteria["megawattsTo"];
        };

        $scope.removePowerOutputFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#powerOutputFilter");
        };


        $scope.showInvalidMessage = function(){
          // this is not very nice looking logic - it is caused by the either/or/both
          // nature of the value range filter as well as the fact that  zero
          // is valid but falsey

          // If I  can get  this subjected to some proper tests, I  might be able to
          // do something about the ugly chain of conditionals

          var showMessage = false;
          if (!angular.isNumber($scope.criteria.megawattsFrom) && $scope.criteria.megawattsFrom != "")
            showMessage = true;

          if(!angular.isNumber($scope.criteria.megawattsTo) && $scope.criteria.megawattsTo != "" )
            showMessage = true;

          if (!$scope.criteria.megawattsTo && !$scope.criteria.megawattsFrom)
            showMessage = true;

          if (angular.isNumber($scope.criteria.megawattsFrom) && !$scope.criteria.megawattsTo)
            showMessage = false;

          if (angular.isNumber($scope.criteria.megawattsTo) && !$scope.criteria.megawattsFrom)
            showMessage = false;

          if(angular.isNumber($scope.criteria.megawattsFrom)
              && angular.isNumber($scope.criteria.megawattsTo)
              && $scope.criteria.megawattsTo <= $scope.criteria.megawattsFrom)
            showMessage = true;

          if ($scope.powerOutputFilterForm.$pristine)
            showMessage = false;


          $scope.powerOutputFilterForm.$setValidity("$valid", !(showMessage || $scope.powerOutputFilterForm.$pristine));
          return showMessage;
        };

      }])
    .directive('powerOutputFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/powerOutputFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
            var txtPowerOutputFrom = iElement.find('#txtPowerOutputFrom');
            txtPowerOutputFrom.attr('placeholder', txtPowerOutputFrom.attr('placeholder-text'));

            var txtPowerOutputTo = iElement.find('#txtPowerOutputTo');
            txtPowerOutputTo.attr('placeholder', txtPowerOutputTo.attr('placeholder-text'));
          },

          controller: 'powerOutputFilterController'
        };
      }]);
//------------------------------------------------------------------------

